export const exportsKeys = {
  all: () => ['exports'] as const,
  list: (page: number) => ['exports', 'list', { page }] as const,
  detail: (id: string) => ['exports', 'detail', id] as const,
}
